<template>
  <v-container>
    <v-row>
      <v-col cols="12" sm="12">
        <div>
          <v-btn
            class="ma-2"
            color="primary"
            outlined
            v-if=" selected.length == 1"
            @click="$router.push('/pump-types-edit/'+selected[0].idpump_type)"
          >Edit</v-btn>
          <v-btn v-if=" selected.length > 0" text @click="deletePumpType" color="red">Delete</v-btn>

          <v-btn class="ma-2" color="primary" @click="$router.push('/pump-types-add')">
            <v-icon left dark>mdi-plus</v-icon>Create Pump Type
          </v-btn>
            
          <v-btn class="ma-2" color="primary" @click="$router.push('/pump-type-add-from-excell')">
            <v-icon left dark>mdi-plus</v-icon>Create Pump Types & Pumps From Excell
          </v-btn>
          
          <v-btn class="ma-2" color="primary" @click="$router.push('/pump-type-info')">
            <v-icon left dark>mdi-information-outline</v-icon>Pump Type Information
          </v-btn>
          
          
        </div>
      </v-col>
    </v-row>

    <v-row>
      <v-card>
        <v-card-title>
          Pump Types
          <v-spacer></v-spacer>
          <v-text-field
            v-model="search"
            append-icon="search"
            label="Search"
            single-line
            hide-details
          ></v-text-field>
        </v-card-title>
        <v-data-table
          item-key="idpump_type"
          :single-select="false"
          show-select
          v-model="selected"
          :headers="headers"
          :items="pumpTypes"
          :search="search"
        ></v-data-table>
      </v-card>
    </v-row>
  </v-container>
</template>

<script>
// const API_URL = "http://localhost:9090/";

export default {
  name: "HelloWorld",
  data: () => ({
    token: "",
    selected: [],
    editPumpTypeId: 100,
    search: "",
    pumpTypes: [],
    headers: [
      {
        text: "Type",
        align: "left",
        sortable: true,
        value: "type",
        width: 120
      },

      // { text: "Frequency (Hz)", value: "frequency" },
      { text: "Outlet Connection Diameter (\")", value: "fi_e" },
      // { text: "Max. Sand Quantity (gr/m^3)", value: "max_sand_quantity", width: 150 },
      { text: "Pump Outside Diameter (mm)", value: "fi_r" },
      // { text: "Material", value: "material", width: 140 },
      // { text: "Number Of Vane", value: "number_of_vane" },
      // { text: "Degree Of Protection", value: "degree_of_protection" },
      // { text: "Voltage", value: "voltage" },
      // { text: "Rotation", value: "rotation" },
      // { text: "Max. Water Temp (C)", value: "max_water_temp"},
      // { text: "Case", value: "case"},
      // { text: "Diffuser", value: "diffuser"},
      // { text: "Impeller", value: "impeller"},
      // { text: "Pump Shaft", value: "pump_shaft"},
      // { text: "Coupling", value: "coupling"},
      // { text: "Strainer", value: "strainer"},
      // { text: "Valve Cap", value: "valve_cap"},
      // { text: "Connection", value: "connection" }
    ],

    pumpType: {
      idpump_type: -1,
      type: "XSP 20",
      frequency: "50",
      outlet_connection_diameter: 100,
      max_sand_quantity : 200,
      pump_outside_diameter : 300,
      number_of_vane : 3,
      degree_of_protection : "IP 68",
      voltage : "100-200",
      rotation : "Clock Wise",
      max_water_temp : "30",
      case : "Stainless Steel",
      diffuser : "Stainless Steel",
      impeller :  "Stainless Steel",
      pump_shaft  : "Stainless Steel",
      coupling :  "Stainless Steel",
      strainer :  "Stainless Steel",
      valve_cap : "Stainless Steel",
      connection : "Based on NEMA Standarts"
    } 
  }),
  mounted: function() {
    if(localStorage.token){
      this.token = localStorage.token
      this.$http.defaults.headers.common['Authorization'] = `Bearer ${this.token}` 
    }
    this.fetchPumpTypes();
  },
  methods: {
    deletePumpType: function() {
      confirm("Are you sure you want to delete this item?") &&
        this.selected.forEach(this.deletePumpTypeRequest);
      this.selected = [];
      console.log("selected bosaltildi.");
    },
    deletePumpTypeRequest: function(pumpType) {
      this.$http
        .get(this.$API_URL + "pump-type-delete?idpump_type=" + pumpType.idpump_type)
        .then(result => {
          console.log(result.data);
          if (this.selected.length == 0) this.fetchPumpTypes();
        });
    },
    fetchPumpTypes: function() {
      this.$http.get(this.$API_URL + "pump_types").then(result => {
        this.pumpTypes = result.data;
      });
    }
  }
};
</script>
